import { useQuery } from '@tanstack/react-query'
import {
  FillRateTimeseries,
  getFillRateTimeseries,
} from 'api/pulse/fillRateTimeseries'
import { PulseFilters } from 'api/pulse'
import { getFillRateTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useFillRateTimeseries(query: PulseFilters) {
  return useQuery<FillRateTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getFillRateTimeseriesKey(query),
    queryFn: ({ signal }) => getFillRateTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
